<ng-container [formGroup]="form">

  <div class="row">

    <div class="mb-3 col-12 spinner" id="search-container">
      <label for="search">Saisissez l'adresse postale *</label>
      <div [ngClass]="{'form-control-spinner': searching}">
        <input class="form-control" id="search" type="search"  value="{{address}}" [ngbTypeahead]="search" [resultTemplate]="rt" (selectItem)="select($event)" [inputFormatter]="formatter"
          [ngClass]="{'is-invalid': $safeNavigationMigration(errors?.length)}" (input)="clearErrors()" placeholder="181 Rue Jean Mermoz 76230 Bois-Guillaume"/>
        <div class="invalid-feedback">{{ errors }}</div>
      </div>
    </div>

    <ng-template #rt let-r="result" let-t="term">
      <ngb-highlight [result]="r.label" [term]="t"></ngb-highlight>
    </ng-template>

    @if (form.get('numero'); as control) {
      <div [class.d-none]="!unlocked" class="mb-3 col-12 col-lg-4">
        <label for="numero">Numéro de voie</label>
        <div class="input-group">
          <input class="form-control" id="numero" type="text" formControlName="numero" [ngClass]="{'is-invalid': !control.valid}" [readOnly]="!unlocked" />
          @if (!unlocked) {
            <div class="input-group-text"><fa-icon [icon]="faLock"></fa-icon></div>
          }
          <div class="invalid-feedback">{{ control.errors }}</div>
        </div>
      </div>
    }

    @if (form.get('nomVoie'); as control) {
      <div [class.d-none]="!unlocked" class="mb-3 col-12 col-lg-4">
        <label for="nomVoie">Nom de voie</label>
        <div class="input-group">
          <input class="form-control" id="nomVoie" type="text" formControlName="nomVoie" [ngClass]="{'is-invalid': !control.valid}" [readOnly]="!unlocked" />
          @if (!unlocked) {
            <div class="input-group-text"><fa-icon [icon]="faLock"></fa-icon></div>
          }
          <div class="invalid-feedback">{{ control.errors }}</div>
        </div>
      </div>
    }

    @if (form.get('nomComplementaire'); as control) {
      <div [class.d-none]="!unlocked" class="mb-3 col-12 col-lg-4">
        <label for="nomComplementaire">Complément d'adresse</label>
        <div class="input-group">
          <input class="form-control" id="nomComplementaire" type="text" formControlName="nomComplementaire" [ngClass]="{'is-invalid': !control.valid}" [readOnly]="!unlocked" />
          @if (!unlocked) {
            <div class="input-group-text"><fa-icon [icon]="faLock"></fa-icon></div>
          }
          <div class="invalid-feedback">{{ control.errors }}</div>
        </div>
      </div>
    }
  </div>
  <div class="row" [class.d-none]="!unlocked">
    @if (form.get('codePostal'); as control) {
      <div class="mb-3 col-12 col-lg-4">
        <label for="codePostal">Code postal *</label>
        <div class="input-group">
          <input class="form-control" id="codePostal" type="text" formControlName="codePostal" [ngClass]="{'is-invalid': !control.valid}" [readOnly]="!unlocked" />
          @if (!unlocked) {
            <div class="input-group-text"><fa-icon [icon]="faLock"></fa-icon></div>
          }
          <div class="invalid-feedback">{{ control.errors }}</div>
        </div>
      </div>
    }

    @if (form.get('nomCommune'); as control) {
      <div class="mb-3 col-12 col-lg-8">
        <label for="nomCommune">Nom de la commune *</label>
        <div class="input-group">
          <input class="form-control" id="nomCommune" type="text" formControlName="nomCommune" [ngClass]="{'is-invalid': !control.valid}"  [readOnly]="!unlocked"/>
          @if (!unlocked) {
            <div class="input-group-text"><fa-icon [icon]="faLock"></fa-icon></div>
          }
          <div class="invalid-feedback">{{ control.errors }}</div>
        </div>
      </div>
    }
  </div>

</ng-container>

<div class="row">
  <div class="mb-3 col-12">
    <div class="form-check">
      <input class="form-check-input" id="readonly1" [(ngModel)]="unlocked" type="checkbox">
      <label class="form-check-label" for="readonly1">Modifier l'adresse</label>
    </div>
  </div>
</div>
